var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-modal',{attrs:{"modal-title":"Aged A/P","no-padding":"true"}},[_c('div',{staticClass:"container"},[_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.items,"exportXls":'exportAgedArToExcel',"title":"Aged A/P"}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e7f5bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/accounting/accounts-payable/reports/ApAgedReport.vue
// module id = OKqx
// module chunks = 0 1